import { getObjectKeysAsObject } from "@checkout/helpers";
import { getWalletOffersService as getWalletOffers } from "./getOffers";

export const services = {
  getWalletOffers,
};

export const ServiceTypes = getObjectKeysAsObject(services);
